export default __webpack_public_path__ + "static/media/te2.b8459f72.png";